// SalesSummary.tsx
import { Card, Typography } from 'antd';
import React from 'react';

const { Title } = Typography;

const SalesSummary: React.FC = () => (
    <Card title={<Title level={4} style={{ margin: 0 }}>Sales Achieved vs Missed</Title>} style={{ height: '100%', width: '100%' }} >
        {/* Placeholder for the Donut Chart */}
        <div style={{ display: 'flex', justifyContent: 'center', alignItems: 'center', flexDirection: 'column', padding: '20px 0' }}>
            {/* The actual chart component (e.g., from react-chartjs-2) would go here */}
            <div style={{ width: 200, height: 200, borderRadius: '50%', border: '30px solid #52C41A', borderLeftColor: '#F5222D', borderTopColor: '#F5222D', transform: 'rotate(20deg)' }}>
            </div>
            {/* Legend */}
            <div style={{ marginTop: 20, display: "flex", justifyContent: "start", width: "100%" }}>
                <div style={{ display: 'flex', alignItems: 'center', marginRight: 10 }}>
                    <div style={{ width: 10, height: 10, backgroundColor: '#52C41A', marginRight: 8 }}></div>
                    <p style={{ margin: 0 }}>Achieved</p>
                </div>
                <div style={{ display: 'flex', alignItems: 'center' }}>
                    <div style={{ width: 10, height: 10, backgroundColor: '#F5222D', marginRight: 8 }}></div>
                    <p style={{ margin: 0 }}>Missed</p>
                </div>
            </div>
        </div>
    </Card>
);

export default SalesSummary;